import { stylesheet } from 'typestyle';

import { colors, font } from '../../assets/styles';

const styles = stylesheet({
  button: {
    position: 'relative',
  },
  largeButton: {
    fontWeight: font.weight.bold,
    fontSize: '16px !important',
    padding: '16px 16px !important',
    borderRadius: '50px !important',
    lineHeight: '16px !important',
    letterSpacing: '-0.12px',
    marginBottom: '10px',
  },
  loader: {
    position: 'relative',
  },
  disabled: {
    background: `${colors.disabledBackground} !important`,
    color: `${colors.disabledText} !important`,
  },
});

export default styles;
